<template>
  <div class="userfrom">
    <div class="container">
      <!-- Content here -->

      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <h5>申請代買委託單</h5>
              <br />
            </div>

            <div class="col-12 mp-3">
              <div>
                <b-form
                  inline
                  @submit="onSubmit"
                  @reset="onReset"
                  v-if="formShow"
                >
                  <div class="col-6 pt-3">
                    <p>代買商品網址:</p>
                  </div>
                  <div class="col-6 pt-3">
                    <b-form-group
                      id="input-group-name"
                      label
                      label-for="input-url"
                    >
                      <b-form-input
                        id="input-url"
                        v-model="form.url"
                        required
                        placeholder="商品網址"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-6 pt-3">
                    <p>商品名稱:</p>
                  </div>
                  <div class="col-6 pt-3">
                    <b-form-group
                      id="input-group-id"
                      label
                      label-for="input-content"
                    >
                      <b-form-input
                        id="input-content"
                        v-model="form.content"
                        required
                        placeholder="品名簡單扼要，如衣服、包包"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-6 pt-3">
                    <p>數量:</p>
                  </div>
                  <div class="col-6 pt-3">
                    <b-form-group
                      id="input-group-id"
                      label
                      label-for="input-quantity"
                    >
                      <b-form-input
                        id="input-quantity"
                        v-model="form.quantity"
                        required
                        placeholder="數量"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-6 pt-3">
                    <p>Email:</p>
                  </div>
                  <div class="col-6 pt-3">
                    <b-form-group
                      id="input-group-id"
                      label
                      label-for="input-email"
                    >
                      <b-form-input
                        id="input-email"
                        v-model="form.email"
                        required
                        placeholder="電子郵件"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-6 pt-3">
                    <p>備註項目:</p>
                  </div>
                  <div class="col-6 pt-3">
                    <b-form-group
                      id="input-group-id"
                      label
                      label-for="input-commit"
                    >
                      <b-form-textarea
                        id="input-commit"
                        v-model="form.commit"
                        placeholder="備註項目"
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                    </b-form-group>
                  </div>

                  <div class="col-6 pt-3">
                    <b-button type="reset" block variant="danger"
                      >重新填寫</b-button
                    >
                  </div>

                  <div class="col-6 pt-3">
                    <b-button type="submit" block variant="primary"
                      >填寫完成</b-button
                    >
                  </div>
                </b-form>
                <br />
                <b-alert show variant="danger" style="text-align: left">
                  代購幫跨國代買服務！
                  <br />
                  <br />Step1.留下您想代買商品連結
                  <br />
                  <br />Step2.我們將會評估商品，並透過聊天室給予報價
                  <br />
                </b-alert>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog />
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
  </div>
</template>

<style type="text/css">
.identityimage {
  width: 100%;
  height: 100%;
}
.captchaImage {
  width: 240px;
  height: 100px;
}
</style>

<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
export default {
  name: 'userfrom',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      webhookApiUrl: process.env.VUE_APP_WEBHOOK_API_URL,
      isLoading: false,
      userId: '',
      userImage: '',
      userName: '',
      prodDatas: '',
      orderDatas: '',
      formShow: true,
      form: {
        url: '',
        content: '',
        email: '',
        quantity: '',
        commit: '',
      },
    }
  },
  watch: {},
  methods: {
    onSubmit(evt) {
      const vm = this
      evt.preventDefault()
      // alert(JSON.stringify(vm.form));
      vm.verifyFrom()
    },
    onReset(evt) {
      const vm = this
      evt.preventDefault()
      // Reset our form values
      vm.form.url = ''
      vm.form.content = ''
      vm.form.email = ''
      vm.form.quantity = ''
      vm.form.commit = ''

      // Trick to reset/clear native browser form validation state
      vm.formShow = false
      vm.$nextTick(() => {
        vm.formShow = true
      })
    },
    checkUnChatbotSignin: function () {
      const vm = this

      try {
        if (
          vm.$route.query.userId &&
          vm.$route.query.userImage &&
          vm.$route.query.userName
        ) {
          localStorage.userId = decodeURI(vm.$route.query.userId)
          localStorage.userImage = decodeURI(vm.$route.query.userImage)
          localStorage.userName = decodeURI(vm.$route.query.userName)
          vm.userId = decodeURI(vm.$route.query.userId)
          vm.userImage = decodeURI(vm.$route.query.userImage)
          vm.userName = decodeURI(vm.$route.query.userName)
        }
      } catch (e) {
        // console.info(e);
        alert(e)
      }

      if (localStorage.userId == undefined) {
        if (vm.userId.length == 0) {
          vm.$modal.show('dialog', {
            title: '🙋您尚未登入FB會員',
            text: '請先登入才能使用此服務喔⚡',
            buttons: [
              {
                title: '👉用FB登入',
                handler: () => {
                  window.location = 'https://m.me/2266831083395361'
                },
              },
            ],
          })
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    addGlobalOrder: function () {
      const vm = this
      vm.isLoading = true
      let userId = localStorage.userId
      let userNickName = localStorage.userName
      let userImage = localStorage.userImage

      if (userId == undefined) {
        userId = vm.userId
        userNickName = vm.userName
        userImage = vm.userImage
      }
      let date = new Date()
      let nowUtc = Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
      )
      let epochMilliSeconds = nowUtc.toString()
      let formData = {
        user_id: userId,
        user_name: userNickName,
        user_image: userImage,
        email: vm.form.email,
        creat_date: epochMilliSeconds,
        status: 0,
        orders: [],
      }

      formData.orders.push({
        prod_url: vm.form.url,
        prod_name: vm.form.content,
        commit: vm.form.commit,
        amount: vm.form.quantity,
      })

      axios
        .post(vm.apiUrl + 'AddGlobalOrder', formData, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        })
        .then(function (response) {
          let orderId = response.data.orderId
          // console.log(data);

          vm.sendBidFbMessageConsumer(
            localStorage.userId,
            'add_global_order',
            orderId
          )
          vm.$toast.open({
            message: '提交成功，請回到聊天室等候通知',
            type: 'success',
          })
          vm.$router.push('orderdone')
          vm.isLoading = false
        })
        .catch(function (error) {
          // console.log(error);
          vm.$toast.open({
            message: '提交失敗: ' + error,
            type: 'error',
          })
        })
    },
    sendBidFbMessageConsumer: function (userId, tempType, orderId) {
      const vm = this

      ;(async function post() {
        let formData = {
          userId: userId,
          tempType: tempType,
          orderId: orderId,
        }
        await axios
          .post(vm.webhookApiUrl + 'SendMsgButtonTemplateV1.1', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            var data = response.data
            if (data.result == 'ok') {
              vm.$toast.open({
                message: '成功發送訊息!',
                type: 'success',
              })
            }
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '發送訊息失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
    verifyFrom: function () {
      const vm = this
      vm.isLoading = true
      if (vm.form.email.length <= 0) {
        vm.$toast.open({
          message: '請確認email正確輸入',
          type: 'error',
        })
        return 0
      } else if (vm.form.url.length <= 0) {
        vm.$toast.open({
          message: '請確認商品連結正確輸入',
          type: 'error',
        })
        return 0
      } else if (vm.form.content.length <= 0) {
        vm.$toast.open({
          message: '請確認商品名稱正確輸入',
          type: 'error',
        })
        return 0
      } else if (vm.form.quantity.length <= 0) {
        vm.$toast.open({
          message: '請確認商品數量正確輸入',
          type: 'error',
        })
        return 0
      }
      vm.addGlobalOrder()
    },
  },
  mounted() {
    const vm = this

    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    vm.checkUnChatbotSignin()
  },
}
</script>
